import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import "../Common/css/styles.css";
import "../Common/css/user.css";
import AdminNoticesComponent from "src/Components/Admin/AdminNoticeComponent";
import InstructorNoticesComponent from "src/Components/Admin/InstructorNoticeComponent";
import AdminNotificationComponent from "src/AdminPages/AdminNotifications";

export default function AdminNotices() {
    const [tab, setTab] = React.useState(0);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    return (
        <div className="comman-outer" style={{ padding: "16px" }}>
            
            {/* Tabs Header */}
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: "#444",
                    background: "#111",
                    borderRadius: "10px 10px 0 0",
                    px: 2
                }}
            >
                <Tabs
                    value={tab}
                    onChange={handleChange}
                    textColor="inherit"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#c6b907ff",
                            height: "3px",
                        },
                    }}
                    sx={{
                        "& .MuiTab-root": {
                            color: "#bbb",
                            fontWeight: 600,
                            textTransform: "none",
                            "&.Mui-selected": {
                                color: "#fff",
                            },
                        },
                    }}
                >
                    <Tab label="Notices" />
                    <Tab label="Instructor Notices" />
                </Tabs>
            </Box>

            {/* Tab Content */}
            <Box sx={{ mt: 2 }}>
                {tab === 0 && (
                    <div style={{backgroundColor: "#dedcdc73", color: "white", padding: "20px" }}>
                        <AdminNoticesComponent />
                    </div>
                )}

                {tab === 1 && (
                    <div style={{backgroundColor: "#dedcdc73", color: "white", padding: "20px" }}>
                        <InstructorNoticesComponent />
                    </div>
                )}
            </Box>
        </div>
    );
}
